/* GT Titanium — storefront interactions (vanilla, no deps) */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Scroll reveal ---------- */
  var reveals = $$("[data-reveal]");
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add("in"); }); }

  /* ---------- Header condense ---------- */
  var header = $("[data-header]");
  if (header) {
    var onScroll = function () { header.classList.toggle("is-scrolled", window.scrollY > 24); };
    onScroll(); window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Mobile nav ---------- */
  var navToggle = $("[data-nav-toggle]");
  if (navToggle) {
    navToggle.addEventListener("click", function () {
      var open = document.body.classList.toggle("nav-open");
      navToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---------- Product gallery ---------- */
  $$("[data-gallery]").forEach(function (gallery) {
    var mainImg = gallery.querySelector("[data-gallery-main] img");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (mainImg && thumb.dataset.full) {
          mainImg.removeAttribute("srcset");
          mainImg.src = thumb.dataset.full;
        }
        gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  });

  /* ---------- Quantity steppers (generic, PDP) ---------- */
  $$("[data-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    if (!input || wrap.hasAttribute("data-line-bound")) return;
    var minus = wrap.querySelector("[data-qty-minus]");
    var plus = wrap.querySelector("[data-qty-plus]");
    if (minus) minus.addEventListener("click", function () { step(input, -1); });
    if (plus) plus.addEventListener("click", function () { step(input, 1); });
  });
  function step(input, dir) {
    var min = parseInt(input.min || "1", 10);
    var v = (parseInt(input.value, 10) || min) + dir;
    if (v < min) v = min;
    input.value = v;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  /* ---------- Variant + selling-plan selection (multi-option) ----------
     Source of truth: Shopify variant + selling_plan_allocation data emitted
     in [data-product-json]. No discount math is done here. */
  $$("[data-product-form]").forEach(function (form) {
    var dataEl = form.querySelector("[data-product-json]");
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var variants = product.variants || [];
    var idInput = form.querySelector("[data-variant-id]");
    var section = form.closest("[data-product-section]");
    var priceEl = section && section.querySelector("[data-price]");
    var compareEl = section && section.querySelector("[data-compare]");
    var payWrap = section && section.querySelector("[data-payment-info]");
    var payText = section && section.querySelector("[data-payment-text]");
    var addBtn = form.querySelector("[data-add]");
    var addText = form.querySelector("[data-add-text]");

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll("[data-option-selector]:checked").forEach(function (r) {
        opts[parseInt(r.dataset.optionPosition, 10) - 1] = r.value;
      });
      return opts;
    }
    function match() {
      var chosen = selectedOptions();
      if (!chosen.length) return variants[0];
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
    }
    function selectedPlanId() {
      var checked = form.querySelector("[data-plan]:checked");
      return checked && checked.value ? checked.value : "";
    }

    function update() {
      var v = match();
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = "Unavailable";
        if (payWrap) payWrap.hidden = true;
        return;
      }
      if (idInput) idInput.value = v.id;

      // Allocation for the chosen selling plan (if any), else the plain variant.
      var planId = selectedPlanId();
      var alloc = planId && v.selling_plans ? v.selling_plans[planId] : null;

      var priceStr = alloc ? alloc.price_formatted : v.price_formatted;
      var compareStr = alloc ? alloc.compare_formatted : v.compare_formatted;

      if (priceEl) priceEl.textContent = priceStr;
      if (compareEl) {
        if (compareStr) { compareEl.textContent = compareStr; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }

      // Deposit / deferred-payment info straight from the allocation.
      if (payWrap && payText) {
        if (alloc && alloc.deferred) {
          payText.innerHTML =
            "Due today <b>" + alloc.checkout_charge_formatted + "</b>" +
            " · Balance <b>" + alloc.remaining_balance_formatted + "</b> charged when it ships.";
          payWrap.hidden = false;
        } else if (alloc && alloc.per_delivery_formatted && alloc.price !== undefined && String(alloc.per_delivery_formatted) !== String(priceStr)) {
          payText.innerHTML = "<b>" + alloc.per_delivery_formatted + "</b> per delivery.";
          payWrap.hidden = false;
        } else {
          payWrap.hidden = true;
        }
      }

      // Button label + availability.
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addText) {
          if (!v.available) addText.textContent = addBtn.dataset.labelSoldout || "Sold out";
          else addText.textContent = planId
            ? (addBtn.dataset.labelPlan || "Pre-order now")
            : (addBtn.dataset.labelOnetime || "Add to cart");
        }
      }
    }

    form.querySelectorAll("[data-option-selector]").forEach(function (r) { r.addEventListener("change", update); });
    form.querySelectorAll("[data-plan]").forEach(function (r) { r.addEventListener("change", update); });
    update(); // sync initial state (handles requires-selling-plan defaults)
  });

  /* ---------- Cart (AJAX) ---------- */
  var drawer = $("[data-cart-drawer]");
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var closeBtn = drawer.querySelector("[data-drawer-close]");
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-drawer-close]")) { e.preventDefault(); closeDrawer(); }
    var cartLink = e.target.closest("[data-cart-toggle]");
    if (cartLink) { e.preventDefault(); openDrawer(); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) closeDrawer();
  });

  function refreshDrawer(sectionsHtml) {
    if (!drawer || !sectionsHtml) return;
    var parsed = new DOMParser().parseFromString(sectionsHtml, "text/html");
    ["[data-cart-items]", "[data-cart-footer]"].forEach(function (sel) {
      var next = parsed.querySelector(sel);
      var cur = drawer.querySelector(sel);
      if (next && cur) cur.replaceWith(next);
      else if (!next && cur) cur.remove();
    });
    var countSrc = parsed.querySelector("[data-cart-count-label]");
    var count = countSrc ? countSrc.textContent.replace(/[()]/g, "").trim() : null;
    if (count !== null) {
      $$("[data-cart-count]").forEach(function (el) { el.textContent = "[" + count + "]"; });
      var label = drawer.querySelector("[data-cart-count-label]");
      if (label) label.textContent = "(" + count + ")";
    }
    bindLineControls();
  }

  function cartRequest(url, body) {
    body.sections = "cart-drawer";
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
  }

  /* Add to cart */
  $$("[data-cart-add]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("[data-add]");
      if (btn) { btn.classList.add("is-loading"); btn.disabled = true; }
      var fd = new FormData(form);
      var body = { items: [{ id: fd.get("id"), quantity: parseInt(fd.get("quantity") || "1", 10) }] };
      var plan = fd.get("selling_plan");
      if (plan) body.items[0].selling_plan = plan;
      cartRequest("/cart/add.js", body).then(function (res) {
        if (btn) { btn.classList.remove("is-loading"); btn.disabled = false; }
        if (!res.ok) { alert((res.data && res.data.description) || "Could not add to cart."); return; }
        if (res.data.sections) refreshDrawer(res.data.sections["cart-drawer"]);
        openDrawer();
      }).catch(function () {
        if (btn) { btn.classList.remove("is-loading"); btn.disabled = false; }
      });
    });
  });

  /* Line item qty + remove (event-delegated on drawer) */
  function changeLine(key, qty) {
    cartRequest("/cart/change.js", { id: key, quantity: qty }).then(function (res) {
      if (res.ok && res.data.sections) refreshDrawer(res.data.sections["cart-drawer"]);
    });
  }
  function bindLineControls() {
    if (!drawer) return;
    drawer.querySelectorAll("[data-line-qty]").forEach(function (input) {
      input.closest("[data-qty]").setAttribute("data-line-bound", "1");
    });
  }
  if (drawer) {
    drawer.addEventListener("click", function (e) {
      var minus = e.target.closest("[data-line-minus]");
      var plus = e.target.closest("[data-line-plus]");
      var remove = e.target.closest("[data-line-remove]");
      if (minus || plus) {
        var key = (minus || plus).dataset.lineKey;
        var input = drawer.querySelector('[data-line-qty][data-line-key="' + key + '"]');
        var q = (parseInt(input.value, 10) || 0) + (plus ? 1 : -1);
        if (q < 0) q = 0;
        changeLine(key, q);
      }
      if (remove) { e.preventDefault(); changeLine(remove.dataset.lineKey, 0); }
    });
    drawer.addEventListener("change", function (e) {
      var input = e.target.closest("[data-line-qty]");
      if (input) changeLine(input.dataset.lineKey, Math.max(0, parseInt(input.value, 10) || 0));
    });
    bindLineControls();
  }
})();
